export enum StatisticsListHintNames {
  TOTAL_GGR = 'totalGgr',
  CASINO_GGR = 'casinoGgr',
  BETTING_GGR = 'bettingGgr',
  TOTAL_NGR = 'totalNgr',
  CASINO_NGR = 'casinoNgr',
  BETTING_NGR = 'bettingNgr',
  TOTAL_RTP = 'totalRtp',
  CASINO_RTP = 'casinoRtp',
  BETTING_RTP = 'bettingRtp',
}
